
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-ssm/contact",
      function () {
        return require("private-next-pages/about-ssm/contact.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-ssm/contact"])
      });
    }
  